<!-- eslint-disable max-len -->
<template>
  <div class="pbx-page">
    <a href="#pbx-main" class="skip-link" data-cta="header_skip_konten" @click.prevent="scrollToId('pbx-main')">{{ $t('pbx.skip') }}</a>

    <!-- HEADER -->
    <header class="site-header" :class="{ scrolled: headerScrolled }">
      <div class="container header-inner">
        <div class="logo"><img class="logo-img" src="/images/img001.png" :alt="$t('pbx.brand')" /></div>
        <nav class="main-nav" aria-label="Paxelbox">
          <a href="#kegunaan" data-cta="header_nav_kegunaan" @click.prevent="scrollToId('kegunaan')">{{ $t('pbx.nav.kegunaan') }}</a>
          <a href="#cara-pakai" data-cta="header_nav_cara_pakai" @click.prevent="scrollToId('cara-pakai')">{{ $t('pbx.nav.caraPakai') }}</a>
          <a href="#ukuran" data-cta="header_nav_ukuran" @click.prevent="scrollToId('ukuran')">{{ $t('pbx.nav.ukuran') }}</a>
          <a href="#lokasi" data-cta="header_nav_lokasi" @click.prevent="scrollToId('lokasi')">{{ $t('pbx.nav.lokasi') }}</a>
          <a href="#faq" data-cta="header_nav_faq" @click.prevent="scrollToId('faq')">{{ $t('pbx.nav.faq') }}</a>
        </nav>
        <div class="header-actions">
          <div class="lang-toggle" role="group" aria-label="Language">
            <button type="button" data-cta="header_bahasa_id" :class="{ active: locale === 'id' }" @click="setLocale('id')">ID</button>
            <button type="button" data-cta="header_bahasa_en" :class="{ active: locale === 'en' }" @click="setLocale('en')">EN</button>
          </div>
          <button class="btn btn-primary btn-sm header-desktop-cta" data-cta="header_cari_paxelbox" @click="trackEvent('click_cari_paxelbox'); scrollToId('lokasi')">{{ $t('pbx.nav.cari') }}</button>
          <button class="hamburger" data-cta="header_buka_menu" :aria-expanded="String(drawerOpen)" aria-controls="pbxDrawer" :aria-label="$t('pbx.nav.cari')" @click="drawerOpen = true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
          </button>
        </div>
      </div>
    </header>

    <div class="drawer-overlay" data-cta="drawer_overlay_tutup" :class="{ open: drawerOpen }" @click="drawerOpen = false"></div>
    <div id="pbxDrawer" class="drawer" :class="{ open: drawerOpen }" role="dialog" aria-modal="true" aria-label="Menu">
      <div class="drawer-top">
        <span class="logo-text">Paxel<b>Box</b></span>
        <button class="drawer-close" data-cta="drawer_tutup" :aria-label="$t('pbx.nav.faq')" @click="drawerOpen = false">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
      </div>
      <nav aria-label="Menu">
        <a href="#kegunaan" data-cta="drawer_nav_kegunaan" @click.prevent="navTo('kegunaan')">{{ $t('pbx.nav.kegunaan') }}</a>
        <a href="#cara-pakai" data-cta="drawer_nav_cara_pakai" @click.prevent="navTo('cara-pakai')">{{ $t('pbx.nav.caraPakai') }}</a>
        <a href="#ukuran" data-cta="drawer_nav_ukuran" @click.prevent="navTo('ukuran')">{{ $t('pbx.nav.ukuran') }}</a>
        <a href="#lokasi" data-cta="drawer_nav_lokasi" @click.prevent="navTo('lokasi')">{{ $t('pbx.nav.lokasi') }}</a>
        <a href="#faq" data-cta="drawer_nav_faq" @click.prevent="navTo('faq')">{{ $t('pbx.nav.faq') }}</a>
      </nav>
      <div class="drawer-cta"><button class="btn btn-primary btn-block" data-cta="drawer_cari_paxelbox" @click="trackEvent('click_cari_paxelbox'); navTo('lokasi')">{{ $t('pbx.nav.cari') }}</button></div>
    </div>

    <main id="pbx-main">
      <!-- HERO -->
      <section class="hero">
        <div class="hero-bg" aria-hidden="true">
          <img class="hero-bg-img" src="/images/hero-titip-barang.jpg" alt="" />
          <div class="hero-bg-overlay"></div>
        </div>
        <div class="container hero-content">
          <div class="hero-copy">
            <span class="eyebrow on-dark">{{ $t('pbx.hero.eyebrow') }}</span>
            <h1 class="display">{{ $t('pbx.hero.headline') }}</h1>
            <p class="hero-support">{{ $t('pbx.hero.support') }}</p>
            <div class="hero-ctas">
              <button class="btn btn-on-dark" data-cta="hero_cari_paxelbox_terdekat" @click="trackEvent('click_cari_paxelbox_terdekat'); scrollToId('lokasi')">{{ $t('pbx.hero.ctaFind') }}</button>
              <button class="btn btn-on-dark-ghost" data-cta="hero_cara_pakai" @click="scrollToId('cara-pakai')">{{ $t('pbx.hero.ctaHow') }}</button>
            </div>
          </div>
        </div>
      </section>

      <!-- LIFESTYLE -->
      <section class="lifestyle-band">
        <div class="container">
          <div class="section-head center"><h2 class="h-section">{{ $t('pbx.lifestyle.heading') }}</h2><p class="sub">{{ $t('pbx.lifestyle.sub') }}</p></div>
          <div class="lifestyle-carousel-wrap">
            <button class="carousel-arrow-sm carousel-arrow-side carousel-arrow-side-prev" data-cta="lifestyle_prev" :disabled="lifestyleAtStart" aria-label="Prev" @click="lifestyleNav(-1)">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>
            </button>
            <div class="lifestyle-grid" ref="lifestyleGrid" @scroll="onLifestyleScroll">
              <div class="lifestyle-card" v-for="(it, i) in lifestyleCards" :key="'ls' + i">
                <div class="lifestyle-visual"><img class="lifestyle-photo" :src="it.image" alt="" loading="lazy" /></div>
                <div class="lifestyle-body">
                  <h3>{{ it.title }}</h3><p>{{ it.context }}</p>
                  <div class="lifestyle-action"><button :data-cta="'lifestyle_aksi_' + (i + 1)" @click="lifestyleAction(it)">{{ it.action }} <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg></button></div>
                </div>
              </div>
            </div>
            <button class="carousel-arrow-sm carousel-arrow-side carousel-arrow-side-next" data-cta="lifestyle_next" :disabled="lifestyleAtEnd" aria-label="Next" @click="lifestyleNav(1)">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg>
            </button>
          </div>
          <div class="carousel-dots" aria-hidden="true"><span class="dot" v-for="(it, i) in lifestyleCards" :key="'lsd' + i" :class="{ active: i === lifestyleIdx }"></span></div>
        </div>
      </section>

      <!-- KEGUNAAN -->
      <section id="kegunaan">
        <div class="container">
          <div class="section-head"><h2 class="h-section">{{ $t('pbx.kegunaan.heading') }}</h2><p class="sub">{{ $t('pbx.kegunaan.sub') }}</p></div>
          <div class="grid-3">
            <div class="card-base kegunaan-card" v-for="(it, i) in kegunaanCards" :key="'kg' + i">
              <div class="kegunaan-visual"><img class="kegunaan-photo" :src="it.image" alt="" loading="lazy" /></div>
              <div class="kegunaan-body">
                <h3 class="h-card">{{ it.title }}</h3><p>{{ it.copy }}</p>
                <div class="card-cta-wrap"><button class="card-cta" :data-cta="'kegunaan_lihat_cara_' + it.flow" @click="kegunaanAction(it)">{{ it.cta }} <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg></button></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- CARA PAKAI -->
      <section id="cara-pakai">
        <div class="container">
          <div class="section-head" style="margin-left:0;text-align:left"><h2 class="h-section">{{ $t('pbx.cara.heading') }}</h2><p class="sub">{{ $t('pbx.cara.sub') }}</p></div>
          <div class="cara-tabs" role="tablist" aria-label="Paxelbox">
            <button class="cara-tab" role="tab" data-cta="cara_pakai_tab_titip" :aria-selected="String(activeFlow === 'titip')" @click="activeFlow = 'titip'">{{ $t('pbx.cara.tabTitip') }}</button>
            <button class="cara-tab" role="tab" data-cta="cara_pakai_tab_ambil" :aria-selected="String(activeFlow === 'ambil')" @click="activeFlow = 'ambil'">{{ $t('pbx.cara.tabAmbil') }}</button>
            <button class="cara-tab" role="tab" data-cta="cara_pakai_tab_kirim" :aria-selected="String(activeFlow === 'dropoff')" @click="activeFlow = 'dropoff'">{{ $t('pbx.cara.tabDropoff') }}</button>
          </div>
          <div class="steps-wrap">
            <div>
              <h3 class="cara-subheading">{{ currentFlow.heading }}</h3>
              <ol class="steps-list">
                <li class="step-item" v-for="(st, i) in currentFlow.steps" :key="'st' + i"><span class="step-num">{{ i + 1 }}</span><div><h3>{{ st.title }}</h3><p>{{ st.text }}</p></div></li>
              </ol>
            </div>
            <div class="cara-visual"><img src="/images/cara-pakai.jpg" alt="" loading="lazy" /></div>
          </div>
        </div>
      </section>

      <!-- UKURAN -->
      <section id="ukuran">
        <div class="container">
          <div class="section-head"><h2 class="h-section">{{ $t('pbx.ukuran.heading') }}</h2><p class="sub">{{ $t('pbx.ukuran.sub') }}</p></div>
          <div class="ukuran-grid-wrap">
            <div>
              <div class="size-grid" role="radiogroup" aria-label="Size">
                <button v-for="sz in sizes" :key="sz.key" type="button" class="size-card" role="radio" :data-cta="'ukuran_pilih_' + String(sz.key).toLowerCase()" :aria-checked="String(activeSize === sz.key)" @click="selectSize(sz.key, true)">
                  <span class="size-letter">{{ sz.key }}</span><span class="size-label">{{ sz.label }}</span>
                </button>
              </div>
              <div class="size-detail">
                <div class="size-detail-text"><b>{{ $t('pbx.ukuran.sizeWord') }} {{ activeSizeObj.key }} — {{ activeSizeObj.label }}</b><p>{{ $t('pbx.ukuran.exampleLabel') }} {{ activeSizeObj.items }}</p></div>
                <span class="badge badge-demo"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="20" height="10" rx="2"/><line x1="6" y1="7" x2="6" y2="11"/><line x1="10" y1="7" x2="10" y2="11"/><line x1="14" y1="7" x2="14" y2="11"/><line x1="18" y1="7" x2="18" y2="11"/></svg> {{ activeSizeObj.dim }} {{ $t('pbx.ukuran.dimSuffix') }}</span>
              </div>
              <div class="size-note-row"><span class="small">{{ $t('pbx.ukuran.note') }}</span></div>
            </div>
            <div class="cabinet-visual"><img src="/images/ukuran-loker.jpg" :alt="$t('pbx.ukuran.heading')" loading="lazy" /></div>
          </div>
          <div class="seli-box-card">
            <span class="seli-box-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="18.5" cy="17.5" r="3.5"/><circle cx="5.5" cy="17.5" r="3.5"/><path d="M12 17.5V14l-3-3 4-3 2 3h2"/></svg></span>
            <div class="seli-box-text">
              <span class="badge badge-demo">{{ $t('pbx.ukuran.seli.badge') }}</span>
              <h3 class="h-card" style="margin-top:8px">{{ $t('pbx.ukuran.seli.title') }}</h3>
              <p>{{ $t('pbx.ukuran.seli.copy') }}</p>
              <span class="seli-box-dim">{{ $t('pbx.ukuran.seli.dim') }}</span>
            </div>
          </div>
        </div>
      </section>

      <!-- TRUST -->
      <section class="trust-band">
        <div class="container">
          <div class="section-head"><h2 class="h-section">{{ $t('pbx.trust.heading') }}</h2><p class="sub">{{ $t('pbx.trust.sub') }}</p></div>
          <div class="grid-3">
            <div class="card-base" v-for="(it, i) in trustCards" :key="'tr' + i"><span class="card-icon-wrap"><img :src="it.image" alt="" loading="lazy" /></span><h3 class="h-card">{{ it.title }}</h3><p>{{ it.copy }}</p></div>
          </div>
        </div>
      </section>

      <!-- LOKASI -->
      <section id="lokasi" class="lokasi-final">
        <div class="container">
          <div class="section-head center"><span class="eyebrow">{{ $t('pbx.lokasi.eyebrow') }}</span><h2 class="h-section">{{ $t('pbx.lokasi.heading') }}</h2><p class="sub">{{ $t('pbx.lokasi.sub') }}</p></div>
          <form class="finder-search" @submit.prevent="doSearch">
            <div class="finder-search-field">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
              <input type="text" v-model="queryInput" :placeholder="$t('pbx.lokasi.searchPlaceholder')" :aria-label="$t('pbx.lokasi.searchPlaceholder')" />
            </div>
            <button type="submit" class="btn btn-primary" data-cta="lokasi_cari_paxelbox">{{ $t('pbx.lokasi.searchBtn') }}</button>
            <button type="button" class="btn btn-ghost" data-cta="lokasi_pakai_lokasiku" @click="useLocation">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3"/></svg>
              {{ $t('pbx.lokasi.useLocation') }}
            </button>
          </form>
          <div v-if="geoState">
            <div class="loc-status">
              <span v-if="geoState === 'busy'" class="spinner"></span>
              <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><line x1="12" y1="8" x2="12" y2="13"/><circle cx="12" cy="16.5" r="0.5" fill="currentColor"/></svg>
              <span>{{ geoState === 'busy' ? $t('pbx.lokasi.geoBusy') : $t('pbx.lokasi.geoUnavailable') }} <button v-if="geoState === 'error'" type="button" class="link-btn" data-cta="lokasi_tutup_pesan_lokasi" @click="geoState = null">{{ $t('pbx.lokasi.dismiss') }}</button></span>
            </div>
          </div>
          <div class="finder-view-toggle" role="group" aria-label="View">
            <button type="button" data-cta="lokasi_tampilan_daftar" :aria-pressed="String(view === 'list')" @click="view = 'list'">{{ $t('pbx.lokasi.viewList') }}</button>
            <button type="button" data-cta="lokasi_tampilan_peta" :aria-pressed="String(view === 'map')" @click="view = 'map'">{{ $t('pbx.lokasi.viewMap') }}</button>
          </div>
          <div class="finder-grid">
            <div class="finder-list" :class="{ 'hide-mobile': view !== 'list' }">
              <div v-if="loadingList" class="finder-state"><span class="spinner" style="margin:0 auto 12px;display:block;"></span>{{ $t('pbx.lokasi.loading') }}</div>
              <div v-else-if="visibleLocations.length === 0" class="finder-state">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 8l-9-5-9 5 9 5 9-5z"/><path d="M3 8v8l9 5 9-5V8"/></svg>
                <p><b>{{ $t('pbx.lokasi.empty') }}</b><br>{{ $t('pbx.lokasi.emptyHint') }}</p>
              </div>
              <template v-else>
                <div class="loc-card" v-for="loc in visibleLocations" :key="loc.id">
                  <div class="loc-card-top"><div><h3>{{ loc.name }}</h3><p class="loc-area">{{ loc.address }}</p></div><span class="badge badge-demo">{{ nearestMode ? $t('pbx.lokasi.nearest') : loc.category }}</span></div>
                  <div class="loc-fields">
                    <div class="loc-field"><span>{{ $t('pbx.lokasi.fieldOpen') }}</span><span>{{ loc.open }}</span></div>
                    <div class="loc-field"><span>{{ $t('pbx.lokasi.fieldHours') }}</span><span>{{ loc.hours }}</span></div>
                    <div class="loc-field"><span>{{ $t('pbx.lokasi.fieldCode') }}</span><span>{{ loc.lockerCode }}</span></div>
                  </div>
                  <div class="loc-actions">
                    <button class="btn btn-ghost btn-sm" :data-cta="'lokasi_petunjuk_arah_' + loc.id" @click="openDirections(loc)">{{ $t('pbx.lokasi.directions') }}</button>
                    <button class="btn btn-secondary btn-sm" :data-cta="'lokasi_detail_' + loc.id" :aria-expanded="String(openDetail === loc.id)" @click="toggleDetail(loc.id)">{{ openDetail === loc.id ? $t('pbx.lokasi.detailClose') : $t('pbx.lokasi.detail') }}</button>
                  </div>
                  <div class="loc-detail-panel" :class="{ open: openDetail === loc.id }">{{ $t('pbx.lokasi.detailPrefix') }} <b>{{ loc.address }}</b>. {{ $t('pbx.lokasi.detailCode') }} {{ loc.lockerCode }}. {{ $t('pbx.lokasi.detailOpen') }} {{ loc.open }}, {{ $t('pbx.lokasi.detailHoursLabel') }} {{ loc.hours }}.</div>
                </div>
                <button v-if="canShowMore" type="button" class="btn btn-ghost btn-block" data-cta="lokasi_lihat_lebih_banyak" @click="showMoreLocations">{{ $t('pbx.lokasi.more') }}<template v-if="searchMode"> ({{ allFiltered.length - visibleLocations.length }})</template></button>
              </template>
            </div>
            <div class="finder-map-wrap" :class="{ 'hide-mobile': view !== 'map' }">
              <div class="map-panel"><iframe :title="$t('pbx.lokasi.mapTitle')" :src="mapUrl" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe></div>
            </div>
          </div>
        </div>
      </section>

      <!-- KOLABORASI -->
      <section class="b2b-cta-section">
        <div class="container">
          <div class="b2b-cta-card">
            <h2 class="h-section">{{ $t('pbx.kolaborasi.heading') }}</h2>
            <div class="b2b-cta-options">
              <div class="b2b-cta-option"><h3>{{ $t('pbx.kolaborasi.opt1Title') }}</h3><p>{{ $t('pbx.kolaborasi.opt1Copy') }}</p></div>
              <div class="b2b-cta-option"><h3>{{ $t('pbx.kolaborasi.opt2Title') }}</h3><p>{{ $t('pbx.kolaborasi.opt2Copy') }}</p></div>
            </div>
            <div class="ads-showcase-wrap">
              <button class="carousel-arrow-sm ads-arrow" data-cta="kolaborasi_iklan_prev" aria-label="Prev" @click="adsScroll(-1)"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg></button>
              <div class="ads-showcase" ref="adsShowcase">
                <div class="ads-thumb" v-for="(ad, i) in adsPhotos" :key="'ad' + i"><img :src="ad.image" :alt="ad.caption" loading="lazy" /></div>
              </div>
              <button class="carousel-arrow-sm ads-arrow" data-cta="kolaborasi_iklan_next" aria-label="Next" @click="adsScroll(1)"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg></button>
            </div>
            <a class="btn btn-primary" data-cta="kolaborasi_ajukan_kerja_sama" href="mailto:paxlok@paxel.co">{{ $t('pbx.kolaborasi.cta') }}</a>
          </div>
        </div>
      </section>

      <!-- PARTNERS -->
      <section class="partners-section">
        <div class="container">
          <div class="section-head center"><h2 class="h-section">{{ $t('pbx.partners.heading') }}</h2></div>
          <div class="partner-marquee-wrap"><div class="partner-marquee-track">
            <div class="partner-logo-item" v-for="(p, i) in partnerLoop" :key="'pl' + i"><img :src="p.image" :alt="p.name" loading="lazy" /></div>
          </div></div>
        </div>
      </section>

      <!-- TESTIMONI -->
      <section class="testimoni-section">
        <div class="container">
          <div class="testimoni-spotlight">
            <div class="testimoni-spotlight-head"><h2 class="h-section">{{ $t('pbx.testimoni.heading') }}</h2><p class="sub">{{ $t('pbx.testimoni.sub') }}</p></div>
            <div class="testimoni-carousel-wrap" @mouseenter="stopTesti" @mouseleave="startTesti">
              <button class="carousel-arrow-sm" data-cta="testimoni_prev" aria-label="Prev" @click="testiNav(-1)"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg></button>
              <div class="testimoni-spotlight-card">
                <div class="testimoni-stars"><svg v-for="n in 5" :key="'star' + n" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l3 6.5 7 .9-5.2 4.8 1.4 6.9-6.2-3.5-6.2 3.5 1.4-6.9L2 9.4l7-.9z"/></svg></div>
                <p class="testimoni-quote">{{ currentTesti.quote }}</p>
                <div class="testimoni-author"><span class="testimoni-avatar">{{ avatarLetter }}</span><div class="testimoni-author-info"><div class="testimoni-author-name">{{ currentTesti.name }}</div><div class="testimoni-author-role">{{ currentTesti.role }}</div></div></div>
              </div>
              <button class="carousel-arrow-sm" data-cta="testimoni_next" aria-label="Next" @click="testiNav(1)"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg></button>
            </div>
            <div class="carousel-dots" aria-hidden="true"><span class="dot" v-for="(t, i) in testimoni" :key="'td' + i" :class="{ active: i === testiIdx }"></span></div>
          </div>
        </div>
      </section>

      <!-- INSTAGRAM -->
      <section class="ig-feed-section">
        <div class="container">
          <div class="ig-feed-content">
            <h2 class="h-section">{{ $t('pbx.ig.heading') }}</h2><p class="sub">{{ $t('pbx.ig.sub') }}</p>
            <a class="ig-handle-pill" data-cta="ig_follow_paxelbox" href="https://www.instagram.com/paxelbox" target="_blank" rel="noopener noreferrer">
              <span class="ig-icon-box"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="2" width="20" height="20" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/></svg></span>
              <span class="ig-handle-text">@paxelbox</span>
            </a>
          </div>
        </div>
      </section>

      <!-- APP DOWNLOAD -->
      <section class="app-download-section">
        <div class="container">
          <div class="app-download-block">
            <h2 class="h-section">{{ $t('pbx.appdl.heading') }}</h2>
            <p class="app-download-text">{{ $t('pbx.appdl.text') }}</p>
            <div class="app-download-badges">
              <a class="app-badge" data-cta="appdl_app_store" :aria-label="$t('pbx.appstoreName')" href="https://apps.apple.com/id/app/paxel-easy-to-send-package/id1372668166?l=id" target="_blank" rel="noopener noreferrer" @click="trackEvent('click_download_app_store')"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8.96-.19 1.95-.87 3.35-.87 1.5 0 2.6.55 3.3 1.44-3.05 1.78-2.55 6.03.28 7.28-.56 1.65-1.28 2.29-1.99 4.32M12.03 7.25c-.15-2.23 1.66-4.09 3.74-4.25.28 2.16-1.99 4.31-3.74 4.25z"/></svg><span><small>{{ $t('pbx.appstoreSmall') }}</small>{{ $t('pbx.appstoreName') }}</span></a>
              <a class="app-badge" data-cta="appdl_google_play" :aria-label="$t('pbx.playName')" href="https://play.google.com/store/apps/details?id=com.paxel&amp;hl=id" target="_blank" rel="noopener noreferrer" @click="trackEvent('click_download_google_play')"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M3.6 2.4l10.5 10.5-3 3L3.6 21.6c-.4-.2-.6-.6-.6-1.1V3.5c0-.5.2-.9.6-1.1zM15 13.9l2.9 2.9-9.7 5.5 6.8-8.4zM18.9 9.6l2.5 1.4c.5.3.8.7.8 1 0 .4-.3.8-.8 1.1l-2.6 1.4-3-3 3.1-2.9zM14.9 10L8.2 2.6 17.8 8.1 14.9 10z"/></svg><span><small>{{ $t('pbx.playSmall') }}</small>{{ $t('pbx.playName') }}</span></a>
            </div>
          </div>
        </div>
      </section>

      <!-- FAQ -->
      <section id="faq">
        <div class="container">
          <div class="section-head"><h2 class="h-section">{{ $t('pbx.faq.heading') }}</h2><p class="sub">{{ $t('pbx.faq.sub') }}</p></div>
          <div class="faq-list">
            <div class="faq-item" v-for="(f, i) in faqItems" :key="'faq' + i">
              <button class="faq-q" :data-cta="'faq_toggle_' + (i + 1)" :aria-expanded="String(openFaq === i)" @click="toggleFaq(i)"><span>{{ f.q }}</span><svg class="faq-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg></button>
              <div class="faq-a" :style="{ maxHeight: openFaq === i ? '520px' : '0px' }"><div class="faq-a-inner">{{ f.a }}</div></div>
            </div>
          </div>
          <div class="faq-bottom">
            <div><span>{{ $t('pbx.faq.stillNeed') }}</span><p class="small" style="margin-top:2px">{{ $t('pbx.faq.heraHours') }}</p></div>
            <a class="btn btn-secondary btn-sm" data-cta="faq_chat_hera" href="https://play.google.com/store/apps/details?id=com.paxel&amp;hl=id" target="_blank" rel="noopener noreferrer">{{ $t('pbx.faq.chatHera') }}</a>
          </div>
        </div>
      </section>
    </main>

    <!-- FOOTER -->
    <footer class="site-footer">
      <div class="container">
        <div class="footer-grid footer-grid-5">
          <div class="footer-col">
            <h4>{{ $t('pbx.footer.aboutPaxel') }}</h4>
            <ul>
              <li><a data-cta="footer_tentang_paxel" class="footer-link-strong" href="https://paxel.co/id/tentang-kami" target="_blank" rel="noopener noreferrer">{{ $t('pbx.footer.l_about') }}</a></li>
              <li><a data-cta="footer_layanan_kami" class="footer-link-strong" href="https://paxel.co/id/layanan-kami" target="_blank" rel="noopener noreferrer">{{ $t('pbx.footer.l_services') }}</a></li>
              <li><a data-cta="footer_pusat_informasi" class="footer-link-strong" href="https://paxel.co/id/pusat-informasi-paxel" target="_blank" rel="noopener noreferrer">{{ $t('pbx.footer.l_info') }}</a></li>
              <li><a data-cta="footer_berita_promo" class="footer-link-strong" href="https://paxel.co/id/berita-dan-promo" target="_blank" rel="noopener noreferrer">{{ $t('pbx.footer.l_news') }}</a></li>
              <li><a data-cta="footer_antarkan_kebaikan" class="footer-link-strong" href="https://paxel.co/id/antarkan-kebaikan" target="_blank" rel="noopener noreferrer">{{ $t('pbx.footer.l_kebaikan') }}</a></li>
            </ul>
          </div>
          <div class="footer-col">
            <h4>{{ $t('pbx.footer.aboutPartnership') }}</h4>
            <ul>
              <li><a data-cta="footer_corporate" href="https://corporate.paxel.co" target="_blank" rel="noopener noreferrer">{{ $t('pbx.footer.l_corporate') }}</a></li>
              <li><a data-cta="footer_mitra_paxel" href="https://paxel.co/id/mitrapaxel" target="_blank" rel="noopener noreferrer">{{ $t('pbx.footer.l_mitra') }}</a></li>
              <li><a data-cta="footer_paxelbig" href="https://paxelbig.paxel.co" target="_blank" rel="noopener noreferrer">{{ $t('pbx.footer.l_big') }}</a></li>
              <li><a data-cta="footer_paxelbox" href="https://paxelbox.paxel.co" target="_blank" rel="noopener noreferrer">{{ $t('pbx.footer.l_box') }}</a></li>
            </ul>
          </div>
          <div class="footer-col">
            <h4><a class="footer-heading-link" data-cta="footer_bantuan" href="https://paxel.co/id/layanan-dan-bantuan" target="_blank" rel="noopener noreferrer">{{ $t('pbx.footer.help') }}</a></h4>
            <ul>
              <li><a data-cta="footer_cek_ongkir" href="https://paxel.co/id/home?cek_ongkir=true" target="_blank" rel="noopener noreferrer">{{ $t('pbx.footer.l_ongkir') }}</a></li>
              <li><a data-cta="footer_cek_resi" href="https://paxel.co/id/lacak-pengiriman" target="_blank" rel="noopener noreferrer">{{ $t('pbx.footer.l_resi') }}</a></li>
            </ul>
            <ul class="footer-list-spaced">
              <li><a data-cta="footer_syarat_ketentuan" class="footer-link-strong" href="https://paxel.co/id/syarat-dan-ketentuan" target="_blank" rel="noopener noreferrer">{{ $t('pbx.footer.l_terms') }}</a></li>
              <li><a data-cta="footer_kebijakan_privasi" class="footer-link-strong" href="https://paxel.co/id/kebijakan-privasi" target="_blank" rel="noopener noreferrer">{{ $t('pbx.footer.l_privacy') }}</a></li>
              <li><a data-cta="footer_karir" class="footer-link-strong" href="https://careers.kula.ai/paxel?source=linkedin" target="_blank" rel="noopener noreferrer">{{ $t('pbx.footer.l_career') }}</a></li>
            </ul>
          </div>
          <div class="footer-col">
            <h4>{{ $t('pbx.footer.complaint') }}</h4>
            <p class="footer-info-text footer-link-strong">{{ $t('pbx.footer.c_company') }}</p>
            <p class="footer-info-text footer-link-strong">{{ $t('pbx.footer.c_email') }}</p>
            <p class="footer-info-text footer-list-spaced">{{ $t('pbx.footer.c_ditjen') }}</p>
            <p class="footer-info-text footer-link-strong">{{ $t('pbx.footer.c_kementerian') }}</p>
            <p class="footer-info-text">{{ $t('pbx.footer.c_wa') }}</p>
          </div>
          <div class="footer-col">
            <h4>{{ $t('pbx.footer.followUs') }}</h4>
            <div class="social-row">
              <a data-cta="footer_sosmed_facebook" aria-label="Facebook" href="http://www.facebook.com/paxel.co" target="_blank" rel="noopener noreferrer"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="9"/><path d="M13.5 21v-6.5h2l.4-2.5h-2.4V10c0-.7.3-1.2 1.3-1.2h1.2V6.1c-.4-.1-1.3-.1-2-.1-2.2 0-3.6 1.4-3.6 3.9V12H8.5v2.5h2V21"/></svg></a>
              <a data-cta="footer_sosmed_instagram" aria-label="Instagram" href="http://www.instagram.com/paxel.co" target="_blank" rel="noopener noreferrer"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1"/></svg></a>
              <a data-cta="footer_sosmed_youtube" aria-label="YouTube" href="https://www.youtube.com/channel/UCGSnDYGVE6dL2U-AX5tLEkg" target="_blank" rel="noopener noreferrer"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="2.5" y="6" width="19" height="12" rx="4"/><path d="M10.8 9.7l4 2.3-4 2.3z" fill="currentColor" stroke="none"/></svg></a>
              <a data-cta="footer_sosmed_threads" aria-label="Threads" href="https://www.threads.com/@paxel.co" target="_blank" rel="noopener noreferrer"><img src="/images/threads-logo.png" alt="" class="threads-icon" loading="lazy" /></a>
              <a data-cta="footer_sosmed_tiktok" aria-label="TikTok" href="https://www.tiktok.com/@paxelindonesia" target="_blank" rel="noopener noreferrer"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M15 3v9.5a3.5 3.5 0 1 1-2.5-3.36"/><path d="M15 3c0 2.5 2 4.5 4.5 4.5"/></svg></a>
            </div>
            <h4 style="margin-top:26px">{{ $t('pbx.footer.downloadApp') }}</h4>
            <div class="footer-app-badges">
              <a class="app-badge" data-cta="footer_google_play" :aria-label="$t('pbx.playName')" href="https://play.google.com/store/apps/details?id=com.paxel&amp;referrer=utm_source%3Dwebrevamp%26utm_medium%3Dbadge" target="_blank" rel="noopener noreferrer"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M3.6 2.4l10.5 10.5-3 3L3.6 21.6c-.4-.2-.6-.6-.6-1.1V3.5c0-.5.2-.9.6-1.1zM15 13.9l2.9 2.9-9.7 5.5 6.8-8.4zM18.9 9.6l2.5 1.4c.5.3.8.7.8 1 0 .4-.3.8-.8 1.1l-2.6 1.4-3-3 3.1-2.9zM14.9 10L8.2 2.6 17.8 8.1 14.9 10z"/></svg><span><small>{{ $t('pbx.playSmall') }}</small>{{ $t('pbx.playName') }}</span></a>
              <a class="app-badge" data-cta="footer_app_store" :aria-label="$t('pbx.appstoreName')" href="https://apps.apple.com/id/app/paxel-easy-to-send-package/id1372668166" target="_blank" rel="noopener noreferrer"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8.96-.19 1.95-.87 3.35-.87 1.5 0 2.6.55 3.3 1.44-3.05 1.78-2.55 6.03.28 7.28-.56 1.65-1.28 2.29-1.99 4.32M12.03 7.25c-.15-2.23 1.66-4.09 3.74-4.25.28 2.16-1.99 4.31-3.74 4.25z"/></svg><span><small>{{ $t('pbx.appstoreSmall') }}</small>{{ $t('pbx.appstoreName') }}</span></a>
            </div>
          </div>
        </div>
        <div class="footer-bottom footer-bottom-brand">
          <div class="footer-brand"><img src="/images/footer-logo.webp" alt="Paxel - Kirim Paket Cepat Aman" class="footer-brand-logo" loading="lazy" /></div>
          <span class="copyright">© {{ year }} Paxel - {{ $t('pbx.footer.rights') }}</span>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
/* eslint-disable */
// Paxelbox refreshed landing. Ported from the marketing mockup (Reza, Sep 2026)
// into an idiomatic Vue 2 SFC. Copy lives in i18n under pbx.* (ID + EN).
//
// SAMPLE / UNVERIFIED CONTENT — see notes for the full list. In short:
//   * Locker sizes S/M/L/XL + SeliBox dimensions are the mockup's SAMPLE values
//     (i18n pbx.ukuran.sizes / pbx.ukuran.seli) — confirm before launch.
//   * Testimonials are the real reviews from the marketing source (confirmed by
//     Pria 2026-09-15): name, role and quote per item under pbx.testimoni.items.
//   * Partner logos are the real marketing partners (confirmed by Pria 2026-09-15);
//     ensure display permission is on file.
//   * Trust claims (e.g. "24/7 CCTV") and B2B/FAQ copy need a factual review.
import { LOCATIONS } from '@/data/locations.js';
import LocalStorage from '@/services/localstorage';

// Current production Google My Maps embed (same mid the live site already uses).
const MAPS_EMBED = 'https://www.google.com/maps/d/u/0/embed?mid=1y09ghAuG25BgwUzJ_Q2KKPMxPGOM_OL8';
// Search / nearest results show this many locations at a time ("Lihat Lebih Banyak" adds more).
const RESULT_PAGE = 2;
const MAPS_URL = `${MAPS_EMBED}&ll=-6.319904878199559%2C106.79377152685174&z=10`;

export default {
  name: 'PaxelboxLanding',
  data() {
    return {
      locale: this.$i18n.locale,
      reduceMotion: false,
      headerScrolled: false,
      drawerOpen: false,
      activeFlow: 'titip',
      activeSize: 'S',
      sizeTimer: null,
      lifestyleIdx: 0,
      lifestyleAtStart: true,
      lifestyleAtEnd: false,
      lifestyleScrollTimer: null,
      queryInput: '',
      query: '',
      loadingList: false,
      expanded: false,
      resultLimit: RESULT_PAGE,
      view: 'list',
      openDetail: null,
      geoState: null,
      nearestMode: false,
      nearestList: [],
      testiIdx: 0,
      testiTimer: null,
      openFaq: -1,
    };
  },
  computed: {
    lifestyleCards() {
      const meta = [
        { image: '/images/lifestyle-olahraga.jpg', type: 'scroll', value: 'lokasi' },
        { image: '/images/lifestyle-konser.jpg', type: 'scroll', value: 'lokasi' },
        { image: '/images/lifestyle-sibuk.jpg', type: 'flow', value: 'ambil' },
        { image: '/images/lifestyle-helm.jpg', type: 'scroll', value: 'ukuran' },
      ];
      const t = this.tm('pbx.lifestyle.items') || [];
      return meta.map((m, i) => Object.assign({}, m, t[i]));
    },
    kegunaanCards() {
      const meta = [
        { image: '/images/kegunaan-titip.jpg', flow: 'titip' },
        { image: '/images/kegunaan-ambil.jpg', flow: 'ambil' },
        { image: '/images/kegunaan-kirim.jpg', flow: 'dropoff' },
      ];
      const t = this.tm('pbx.kegunaan.items') || [];
      return meta.map((m, i) => Object.assign({}, m, t[i]));
    },
    currentFlow() {
      return this.tm('pbx.cara.flows.' + this.activeFlow) || { heading: '', steps: [] };
    },
    sizes() {
      return this.tm('pbx.ukuran.sizes') || [];
    },
    activeSizeObj() {
      return this.sizes.find((s) => s.key === this.activeSize) || this.sizes[0] || {};
    },
    trustCards() {
      const imgs = ['/images/img013.png', '/images/img014.png', '/images/img015.png', '/images/img016.png', '/images/img017.png', '/images/img018.png'];
      const t = this.tm('pbx.trust.items') || [];
      return t.map((it, i) => Object.assign({ image: imgs[i] }, it));
    },
    adsPhotos() {
      const imgs = ['/images/ads-kerjasama.jpg', '/images/ads-kolaborasi.jpg', '/images/ads-branding.jpg', '/images/ads-media.jpg'];
      const a = this.tm('pbx.ads') || {};
      const caps = [a.kerjasama, a.kolaborasi, a.branding, a.media];
      return imgs.map((image, i) => ({ image, caption: caps[i] }));
    },
    testimoni() {
      return this.tm('pbx.testimoni.items') || [];
    },
    currentTesti() {
      return this.testimoni[this.testiIdx] || this.testimoni[0] || { quote: '' };
    },
    avatarLetter() {
      return (this.currentTesti.name || 'P').charAt(0);
    },
    faqItems() {
      return this.tm('pbx.faq.items') || [];
    },
    allFiltered() {
      const base = this.nearestMode ? this.nearestList : LOCATIONS;
      const q = this.query.toLowerCase();
      if (!q) return base;
      return base.filter((l) => [l.name, l.address, l.category, l.lockerCode].some((f) => (f || '').toLowerCase().indexOf(q) > -1));
    },
    searchMode() {
      return !!this.query || this.nearestMode;
    },
    visibleLocations() {
      const r = this.allFiltered;
      if (this.searchMode) return r.slice(0, this.resultLimit);
      if (!this.expanded) return r.slice(0, 3);
      return r;
    },
    // The My Maps embed always draws every locker pin; re-center and zoom it on the opened
    // location, or on the search / nearest results currently shown, so those pins are in view.
    mapUrl() {
      const opened = this.visibleLocations.find((l) => l.id === this.openDetail);
      let pts = [];
      if (opened) pts = [opened];
      else if (this.searchMode) pts = this.visibleLocations;
      pts = pts.filter((l) => l.lat != null && l.lng != null);
      if (!pts.length) return MAPS_URL;
      const lats = pts.map((l) => l.lat); const lngs = pts.map((l) => l.lng);
      const minLat = Math.min(...lats); const maxLat = Math.max(...lats);
      const minLng = Math.min(...lngs); const maxLng = Math.max(...lngs);
      const span = Math.max(maxLat - minLat, maxLng - minLng);
      const z = span < 0.002 ? 17 : Math.max(10, Math.min(17, Math.round(Math.log2(360 / span))));
      return `${MAPS_EMBED}&ll=${(minLat + maxLat) / 2}%2C${(minLng + maxLng) / 2}&z=${z}`;
    },
    canShowMore() {
      if (!this.searchMode && this.expanded) return false;
      return this.allFiltered.length > this.visibleLocations.length;
    },
    partners() {
      // Real partners from the marketing source (confirmed by Pria, 2026-09-15).
      return [
        { name: 'MRT Jakarta', image: '/images/img023.png' },
        { name: 'GBK', image: '/images/img024.png' },
        { name: 'Ancol', image: '/images/img025.png' },
        { name: 'Bank Syariah Indonesia', image: '/images/img026.png' },
        { name: 'Agora Lifestyle Mall', image: '/images/img027.png' },
      ];
    },
    partnerLoop() {
      // Duplicated so the marquee loops seamlessly (matches the mockup).
      return this.partners.concat(this.partners);
    },
    year() {
      return new Date().getFullYear();
    },
  },
  methods: {
    // Locale-aware raw message lookup (returns arrays/objects; $t is string-only).
    tm(key) {
      const loc = this.$i18n.locale;
      const msgs = this.$i18n.messages;
      const walk = (o) => key.split('.').reduce((a, k) => (a && a[k] != null ? a[k] : undefined), o);
      let v = walk(msgs[loc]);
      if (v === undefined) v = walk(msgs[this.$i18n.fallbackLocale || 'id']);
      return v;
    },
    setLocale(l) {
      this.$i18n.locale = l;
      this.locale = l;
      try { LocalStorage.setLanguage(l); } catch (e) { /* ignore */ }
    },
    scrollToId(id) {
      const el = document.getElementById(id);
      if (!el) return;
      // Land the section just under the sticky header. scrollIntoView would stack the global
      // html scroll-padding-top (sized for the other pages' taller header) on top of the
      // section's scroll-margin-top and leave a large gap above the section.
      const header = this.$el.querySelector('header.site-header');
      const top = el.getBoundingClientRect().top + window.pageYOffset - (header ? header.offsetHeight : 0);
      window.scrollTo({ top: Math.max(0, top), behavior: this.reduceMotion ? 'auto' : 'smooth' });
    },
    trackEvent(name) {
      // GA4 custom event (gtag is loaded from public/gtag.js).
      if (typeof window.gtag === 'function') window.gtag('event', name);
    },
    navTo(id) {
      this.drawerOpen = false;
      this.$nextTick(() => this.scrollToId(id));
    },
    lifestyleAction(it) {
      if (it.type === 'flow') { this.activeFlow = it.value; this.scrollToId('cara-pakai'); } else { this.scrollToId(it.value); }
    },
    lifestyleStep(grid) {
      const cards = grid.querySelectorAll('.lifestyle-card');
      return cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : grid.clientWidth;
    },
    lifestyleNav(dir) {
      const grid = this.$refs.lifestyleGrid;
      if (!grid) return;
      grid.scrollBy({ left: dir * this.lifestyleStep(grid), behavior: this.reduceMotion ? 'auto' : 'smooth' });
      // Fallback in case the browser doesn't fire a scroll event once the scroll settles.
      clearTimeout(this.lifestyleScrollTimer);
      this.lifestyleScrollTimer = setTimeout(this.updateLifestyleState, 500);
    },
    // Arrows follow the real scroll position: on wide screens several cards are visible, so the
    // grid's end is reached long before the last card's left edge.
    updateLifestyleState() {
      const grid = this.$refs.lifestyleGrid;
      if (!grid) return;
      const cards = grid.querySelectorAll('.lifestyle-card');
      if (!cards.length) return;
      const n = cards.length;
      const max = grid.scrollWidth - grid.clientWidth;
      // How far the first card has scrolled past the grid's left edge (the grid's own padding
      // and scroll-snap mean the start position isn't exactly scrollLeft 0).
      const scrolled = grid.getBoundingClientRect().left - cards[0].getBoundingClientRect().left;
      this.lifestyleAtStart = scrolled <= 2;
      this.lifestyleAtEnd = grid.scrollLeft >= max - 2;
      this.lifestyleIdx = this.lifestyleAtEnd
        ? n - 1 : Math.max(0, Math.min(n - 1, Math.round(scrolled / this.lifestyleStep(grid))));
    },
    onLifestyleScroll() {
      clearTimeout(this.lifestyleScrollTimer);
      this.lifestyleScrollTimer = setTimeout(this.updateLifestyleState, 100);
    },
    kegunaanAction(it) {
      this.activeFlow = it.flow;
      this.scrollToId('cara-pakai');
    },
    selectSize(key, user) {
      this.activeSize = key;
      if (user) { this.stopSizeAuto(); this.startSizeAuto(); }
    },
    startSizeAuto() {
      if (this.reduceMotion) return;
      this.stopSizeAuto();
      this.sizeTimer = setInterval(() => {
        const i = this.sizes.findIndex((s) => s.key === this.activeSize);
        const next = this.sizes[(i + 1) % this.sizes.length];
        if (next) this.activeSize = next.key;
      }, 2000);
    },
    stopSizeAuto() { if (this.sizeTimer) { clearInterval(this.sizeTimer); this.sizeTimer = null; } },
    doSearch() {
      this.query = this.queryInput.trim();
      this.expanded = false;
      this.resultLimit = RESULT_PAGE;
      this.nearestMode = false;
      this.loadingList = true;
      setTimeout(() => { this.loadingList = false; }, this.reduceMotion ? 0 : 350);
    },
    useLocation() {
      if (!navigator.geolocation) { this.geoState = 'error'; return; }
      this.geoState = 'busy';
      navigator.geolocation.getCurrentPosition(
        (p) => {
          const la = p.coords.latitude; const lo = p.coords.longitude;
          const withD = LOCATIONS.filter((l) => l.lat != null && l.lng != null)
            .map((l) => Object.assign({}, l, { _d: this.haversine(la, lo, l.lat, l.lng) }));
          withD.sort((a, b) => a._d - b._d);
          this.nearestList = withD;
          this.nearestMode = true;
          this.query = ''; this.queryInput = ''; this.expanded = false; this.resultLimit = RESULT_PAGE;
          this.geoState = null;
        },
        () => { this.geoState = 'error'; },
        { enableHighAccuracy: false, timeout: 8000, maximumAge: 60000 },
      );
    },
    haversine(la1, lo1, la2, lo2) {
      const R = 6371; const d2r = Math.PI / 180;
      const dLa = (la2 - la1) * d2r; const dLo = (lo2 - lo1) * d2r;
      const a = Math.sin(dLa / 2) ** 2 + Math.cos(la1 * d2r) * Math.cos(la2 * d2r) * Math.sin(dLo / 2) ** 2;
      return 2 * R * Math.asin(Math.sqrt(a));
    },
    openDirections(loc) {
      window.open('https://www.google.com/maps/dir/?api=1&destination=' + loc.lat + ',' + loc.lng, '_blank', 'noopener');
    },
    showMoreLocations() {
      if (this.searchMode) this.resultLimit += RESULT_PAGE;
      else this.expanded = true;
    },
    toggleDetail(id) { this.openDetail = this.openDetail === id ? null : id; },
    adsScroll(dir) {
      const el = this.$refs.adsShowcase;
      if (el) el.scrollBy({ left: dir * 190, behavior: this.reduceMotion ? 'auto' : 'smooth' });
    },
    testiNav(dir) {
      const n = this.testimoni.length || 1;
      this.testiIdx = (this.testiIdx + dir + n) % n;
      this.stopTesti(); this.startTesti();
    },
    startTesti() {
      if (this.reduceMotion) return;
      this.stopTesti();
      this.testiTimer = setInterval(() => {
        const n = this.testimoni.length || 1;
        this.testiIdx = (this.testiIdx + 1) % n;
      }, 4500);
    },
    stopTesti() { if (this.testiTimer) { clearInterval(this.testiTimer); this.testiTimer = null; } },
    toggleFaq(i) { this.openFaq = this.openFaq === i ? -1 : i; },
    onScroll() { this.headerScrolled = window.scrollY > 10; },
  },
  mounted() {
    this.reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onLifestyleScroll);
    this.onScroll();
    this.$nextTick(this.updateLifestyleState);
    this.startSizeAuto();
    this.startTesti();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onLifestyleScroll);
    this.stopSizeAuto();
    this.stopTesti();
    clearTimeout(this.lifestyleScrollTimer);
  },
};
</script>

<style scoped>

/* Paxelbox refresh styles — ported from marketing mockup (Reza), scoped to .pbx-page. */

/* ---------- Reset ---------- */
*, *::before, *::after { box-sizing: border-box; }
body { margin: 0; }
h1,h2,h3,h4,p,ul,figure { margin: 0; }
ul { padding: 0; list-style: none; }
button { font: inherit; color: inherit; background: none; border: none; cursor: pointer; }
input, select, textarea { font: inherit; color: inherit; }
a { color: inherit; text-decoration: none; }
img, svg { display: block; max-width: 100%; }

/* ---------- Design tokens ---------- */
.pbx-page{
  --purple: #5E50A1;
  --purple-dark: #473c80;
  --purple-tint: #EDE9FA;
  --yellow: #F7C948;
  --yellow-dark: #E3B32E;
  --lilac: #F2EFFE;
  --offwhite: #FAFAFC;
  --white: #FFFFFF;
  --dark: #404040;
  --medium: #6B6B76;
  --border: #E7E5EE;
  --green: #2E9E5B;
  --green-bg: #E8F7EE;
  --verify-bg: #FFF3D6;
  --verify-text: #7A5B00;

  --font: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;

  --radius-sm: 12px;
  --radius-md: 18px;
  --radius-lg: 28px;

  --shadow-soft: 0 2px 16px rgba(64,64,64,0.07);
  --shadow-med: 0 12px 32px rgba(94,80,161,0.16);

  --maxw: 1240px;
  --header-h: 76px;
}

@media (prefers-reduced-motion: reduce){
  *, *::before, *::after{
    animation-duration: 0.001ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.001ms !important;
    scroll-behavior: auto !important;
  }
}


.pbx-page{
  font-family: var(--font);
  color: var(--dark);
  background: var(--offwhite);
  line-height: 1.6;
  -webkit-font-smoothing: antialiased;
}

/* ---------- Layout helpers ---------- */
.container{ max-width: var(--maxw); margin: 0 auto; padding: 0 24px; }
@media (max-width: 767px){ .container{ padding: 0 20px; } }

section{ padding: 72px 0; scroll-margin-top: 96px; }
@media (max-width: 767px){ section{ padding: 52px 0; } }

.section-head{ max-width: 640px; margin-bottom: 40px; }
.section-head.center{ margin-left:auto; margin-right:auto; text-align:center; }

.eyebrow{
  display:inline-block;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--purple);
  background: var(--purple-tint);
  padding: 6px 14px;
  border-radius: 999px;
  margin-bottom: 16px;
}
.eyebrow.on-dark{ background: rgba(255,255,255,0.14); color: var(--white); }

h1.display{
  font-size: clamp(2.1rem, 5vw, 3.4rem);
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: -0.01em;
}
h2.h-section{
  font-size: clamp(1.65rem, 3.2vw, 2.3rem);
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: -0.01em;
}
h3.h-card{ font-size: 1.15rem; font-weight: 700; line-height: 1.35; }
.sub{ font-size: 1.05rem; color: var(--medium); margin-top: 14px; }
.small{ font-size: 0.875rem; color: var(--medium); }
.muted-note{ font-size: 0.8125rem; color: var(--medium); margin-top: 10px; }

/* ---------- Badges: verify / demo (structural labeling system) ---------- */
.badge{
  display:inline-flex; align-items:center; gap:6px;
  font-size: 0.75rem; font-weight: 700;
  padding: 4px 10px; border-radius: 999px;
  white-space: nowrap;
}
.badge svg{ width:13px; height:13px; flex-shrink:0; }
.badge-verify{ background: var(--verify-bg); color: var(--verify-text); }
.badge-demo{ background: var(--purple-tint); color: var(--purple); }

/* ---------- Buttons ---------- */
.btn{
  display:inline-flex; align-items:center; justify-content:center; gap:8px;
  font-weight: 700; font-size: 0.9375rem;
  padding: 13px 24px; border-radius: 999px;
  min-height: 44px;
  transition: transform .15s ease, box-shadow .15s ease, background .15s ease, color .15s ease;
  border: 2px solid transparent;
}
.btn svg{ width:18px; height:18px; }
.btn:hover{ transform: translateY(-1px); }
.btn-primary{ background: var(--purple); color: var(--white); }
.btn-primary:hover{ background: var(--purple-dark); box-shadow: var(--shadow-med); }
.btn-secondary{ background: transparent; color: var(--purple); border-color: var(--purple); }
.btn-secondary:hover{ background: var(--purple-tint); }
.btn-on-dark{ background: var(--white); color: var(--purple); }
.btn-on-dark:hover{ background: var(--yellow); color: var(--dark); }
.btn-on-dark-ghost{ background: transparent; color: var(--white); border-color: rgba(255,255,255,0.55); }
.btn-on-dark-ghost:hover{ background: rgba(255,255,255,0.12); }
.btn-yellow{ background: var(--yellow); color: var(--dark); }
.btn-yellow:hover{ background: var(--yellow-dark); box-shadow: var(--shadow-med); }
.btn-ghost{ background: transparent; color: var(--dark); border-color: var(--border); }
.btn-ghost:hover{ background: var(--lilac); }
.btn-sm{ padding: 9px 16px; font-size: 0.8125rem; min-height: 40px; }
.btn-block{ width: 100%; }
.btn[disabled]{ opacity: 0.55; cursor: not-allowed; transform:none !important; }

.btn:focus-visible, a:focus-visible, input:focus-visible, select:focus-visible,
textarea:focus-visible, [tabindex]:focus-visible, .filter-chip:focus-visible {
  outline: 3px solid var(--purple);
  outline-offset: 2px;
}
.on-purple :focus-visible, .hero-content :focus-visible{ outline-color: var(--yellow); }

/* ---------- Skip link ---------- */
.skip-link{
  position:absolute; left:12px; top:-60px; z-index:1000;
  background: var(--purple); color:#fff; padding:12px 18px; border-radius: 10px;
  transition: top .15s ease; font-weight:700; font-size:0.875rem;
}
.skip-link:focus{ top:12px; }

/* ---------- Header ---------- */
header.site-header{
  position: sticky; top:0; z-index: 500;
  background: rgba(250,250,252,0.92);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid transparent;
  transition: box-shadow .2s ease, border-color .2s ease;
}
header.site-header.scrolled{ box-shadow: var(--shadow-soft); border-color: var(--border); }
.header-inner{
  height: var(--header-h);
  display:flex; align-items:center; justify-content:space-between; gap: 20px;
}
.logo{ display:flex; align-items:center; gap:10px; font-weight:800; font-size:1.05rem; flex-shrink:0; }
.logo-img{ height: 30px; width:auto; display:block; }
.logo-mark{
  width: 38px; height:38px; border-radius: 11px; background: var(--purple);
  display:flex; align-items:center; justify-content:center; flex-shrink:0;
}
.logo-mark svg{ width:20px; height:20px; }
.logo-text b{ color: var(--purple); }
.logo-sub{ display:block; font-size:0.6875rem; font-weight:600; color: var(--medium); letter-spacing:0.02em; }

nav.main-nav{ display:flex; align-items:center; gap: 4px; }
nav.main-nav a{
  padding: 10px 14px; border-radius: 999px; font-weight:600; font-size:0.9375rem; color: var(--dark);
  transition: background .15s ease, color .15s ease;
}
nav.main-nav a:hover{ background: var(--lilac); color: var(--purple); }

.header-actions{ display:flex; align-items:center; gap:10px; flex-shrink:0; }
.hamburger{
  display:none; width:44px; height:44px; border-radius:12px; align-items:center; justify-content:center;
  background: var(--lilac);
}
.hamburger svg{ width:22px; height:22px; }

@media (max-width: 1024px){
  nav.main-nav{ display:none; }
  .header-desktop-cta{ display:none; }
  .hamburger{ display:flex; }
}

/* Mobile drawer */
.drawer-overlay{
  position: fixed; inset:0; background: rgba(64,64,64,0.42); z-index: 600;
  opacity:0; pointer-events:none; transition: opacity .2s ease;
}
.drawer-overlay.open{ opacity:1; pointer-events:auto; }
.drawer{
  position: fixed; top:0; right:0; bottom:0; width: min(320px, 84vw); background: var(--white);
  z-index: 601; box-shadow: -8px 0 32px rgba(64,64,64,0.18);
  transform: translateX(100%); transition: transform .25s ease;
  display:flex; flex-direction:column; padding: 22px;
}
.drawer.open{ transform: translateX(0); }
.drawer-top{ display:flex; justify-content:space-between; align-items:center; margin-bottom: 18px; }
.drawer-close{ width:40px; height:40px; border-radius:10px; background: var(--lilac); display:flex; align-items:center; justify-content:center; }
.drawer-close svg{ width:18px; height:18px; }
.drawer nav{ display:flex; flex-direction:column; gap:2px; }
.drawer nav a{ padding: 14px 10px; border-radius:10px; font-weight:700; font-size:1.05rem; border-bottom:1px solid var(--border); }
.drawer nav a:hover{ background: var(--lilac); }
.drawer-cta{ margin-top:auto; padding-top:18px; }

/* Mobile sticky bottom CTA */
.mobile-sticky-cta{ display:none; }
@media (max-width: 767px){
  .mobile-sticky-cta{
    display:block; position: fixed; left:0; right:0; bottom:0; z-index: 400;
    background: var(--white); border-top:1px solid var(--border);
    padding: 12px 20px calc(12px + env(safe-area-inset-bottom));
    box-shadow: 0 -6px 20px rgba(64,64,64,0.08);
  }
  .pbx-page{ padding-bottom: 82px; }
}

/* ============================================================
   HERO (full-bleed landscape banner)
   ============================================================ */
.hero{
  position:relative; overflow:hidden; padding:0;
  min-height: 560px; display:flex; align-items:center;
}
.hero-bg{ position:absolute; inset:0; z-index:0; }
.hero-bg-img{ width:100%; height:100%; object-fit:cover; object-position: 58% center; display:block; }
.hero-bg-overlay{
  position:absolute; inset:0; z-index:1;
  background: linear-gradient(100deg, rgba(20,14,42,0.78) 0%, rgba(20,14,42,0.58) 32%, rgba(20,14,42,0.24) 58%, rgba(20,14,42,0.05) 80%);
}
.hero-content{ position:relative; z-index:1; padding: 88px 24px; width:100%; }
.hero-copy{ max-width: 560px; }
.hero-copy .eyebrow{ margin-bottom:16px; }
.hero-copy h1.display{ color: var(--white); white-space: pre-line; }
.hero-copy p.hero-support{ font-size: 1.1rem; color: rgba(255,255,255,0.88); margin-top: 18px; text-wrap: pretty; }
.hero-ctas{ display:flex; flex-wrap:wrap; gap: 14px; margin-top: 28px; }
.hero-note{ margin-top: 14px; font-size: 0.875rem; color: rgba(255,255,255,0.75); }
@media (max-width: 767px){
  .hero{ min-height: calc(100vh - var(--header-h)); min-height: calc(100svh - var(--header-h)); align-items: flex-start; }
  .hero-bg-img{ object-position: 83% center; }
  .hero-bg-overlay{ background: rgba(20,14,42,0.6); }
  .hero-content{ padding: 48px 20px; }
  .hero-ctas{ flex-direction:column; gap:12px; }
  .hero-ctas .btn{ width:100%; padding:14px 20px; font-size:0.9375rem; }
}

.loc-status{
  display:flex; align-items:flex-start; gap:10px; background: var(--verify-bg); color: var(--verify-text);
  border-radius: var(--radius-sm); padding: 12px 14px; font-size: 0.85rem; margin-top: 12px;
}
.loc-status svg{ width:16px; height:16px; flex-shrink:0; margin-top:2px; }
.spinner{
  width:16px; height:16px; border-radius:50%; border: 2px solid var(--purple-tint); border-top-color: var(--purple);
  animation: spin .7s linear infinite; flex-shrink:0;
}
@keyframes spin{ to{ transform: rotate(360deg); } }

/* ---------- Generic card grid ---------- */
.grid-3{ display:grid; grid-template-columns: repeat(3,1fr); gap: 22px; }
@media (max-width: 900px){ .grid-3{ grid-template-columns: repeat(2,1fr); } }
@media (max-width: 560px){ .grid-3{ grid-template-columns: 1fr; } }
.grid-4{ display:grid; grid-template-columns: repeat(4,1fr); gap: 20px; }
@media (max-width: 1024px){ .grid-4{ grid-template-columns: repeat(2,1fr); } }
@media (max-width: 560px){ .grid-4{ grid-template-columns: 1fr; } }

.card-base{
  background: var(--white); border: 1px solid var(--border); border-radius: var(--radius-md);
  padding: 26px; transition: box-shadow .2s ease, transform .2s ease;
  display:flex; flex-direction:column;
}
.card-base:hover{ box-shadow: var(--shadow-med); transform: translateY(-4px) rotate(-0.6deg); }
.card-icon-wrap{
  width:64px; height:64px; border-radius:14px; background: var(--purple-tint);
  display:flex; align-items:center; justify-content:center; margin-bottom:16px;
}
.card-icon-wrap svg{ width:24px; height:24px; color: var(--purple); }
.card-icon-wrap img{ width:100%; height:100%; object-fit:contain; }
.card-base p{ color: var(--medium); font-size:0.9375rem; margin-top:8px; }
.card-cta{ margin-top:18px; display:inline-flex; align-items:center; gap:6px; font-weight:700; font-size:0.875rem; color: var(--purple); }
.card-note{ display:flex; align-items:flex-start; gap:8px; background: var(--lilac); border-radius: var(--radius-sm); padding: 10px 12px; font-size:0.8125rem; color: var(--dark); margin-top:14px; line-height:1.4; }
.card-note svg{ width:15px; height:15px; color: var(--purple); flex-shrink:0; margin-top:1px; }
.card-cta svg{ width:15px; height:15px; }
.card-cta-wrap{ margin-top:auto; padding-top:18px; }
.card-cta-btn{
  display:inline-flex; align-items:center; gap:6px;
  background: var(--purple); color:#fff; font-weight:700; font-size:0.875rem;
  padding: 11px 20px; border-radius:999px; min-height:44px;
  transition: background .15s ease, transform .15s ease, box-shadow .15s ease;
}
.card-cta-btn:hover{ background: var(--purple-dark); transform: translateY(-1px); box-shadow: var(--shadow-soft); }
.card-cta-btn svg{ width:15px; height:15px; }

.kegunaan-card{ padding:0; overflow:hidden; }
.kegunaan-visual{ position:relative; height:170px; background: var(--lilac); display:flex; align-items:center; justify-content:center; overflow:hidden; }
.kegunaan-visual-icon svg{ width:56px; height:56px; color: var(--purple); }
.kegunaan-photo{ width:100%; height:100%; object-fit:cover; display:block; }
.kegunaan-body{ padding: 22px 24px 26px; display:flex; flex-direction:column; flex:1; }
.kegunaan-body p{ color: var(--medium); font-size:0.9375rem; margin-top:8px; }

/* ---------- Lifestyle use cases (carousel) ---------- */
.lifestyle-band{ background: var(--lilac); }
.lifestyle-carousel-wrap{ position:relative; }
.lifestyle-grid{
  display:flex; gap:20px; overflow-x:auto; scroll-snap-type:x mandatory;
  -webkit-overflow-scrolling:touch; scrollbar-width:none; padding: 4px 4px 10px;
}
.lifestyle-grid::-webkit-scrollbar{ display:none; height:0; }
.lifestyle-card{
  flex: 0 0 clamp(240px, 32%, 320px); scroll-snap-align:start;
  background: var(--white); border-radius: var(--radius-md); overflow:hidden; border:1px solid var(--border);
  display:flex; flex-direction:column; transition: box-shadow .2s ease, transform .2s ease;
}
@media (max-width: 900px){ .lifestyle-card{ flex-basis: 48%; } }
@media (max-width: 640px){ .lifestyle-card{ flex-basis: 100%; } .lifestyle-grid{ gap:0; } }
.lifestyle-card:hover{ box-shadow: var(--shadow-med); transform: translateY(-4px) rotate(0.6deg); }
.lifestyle-visual{ height:200px; display:flex; align-items:center; justify-content:center; background: var(--lilac); overflow:hidden; }
.lifestyle-visual svg{ width:64px; height:64px; color: var(--purple); }
.lifestyle-photo{ width:100%; height:100%; object-fit:cover; display:block; }
.lifestyle-body{ padding: 22px 22px 26px; display:flex; flex-direction:column; align-items:center; text-align:center; gap:6px; flex:1; }
.lifestyle-body h3{ font-size:1.15rem; font-weight:800; }
.lifestyle-body p{ font-size:0.9375rem; color: var(--medium); }
.lifestyle-action{ margin-top:auto; padding-top:16px; display:flex; justify-content:center; }
.lifestyle-action button{
  display:inline-flex; align-items:center; gap:6px; font-weight:700; font-size:0.875rem; color:#fff;
  background: var(--purple); padding: 11px 22px; border-radius:999px; min-height:44px;
  transition: background .15s ease, transform .15s ease;
}
.lifestyle-action button:hover{ background: var(--purple-dark); transform: translateY(-1px); }
.lifestyle-action button svg{ display:none; }

/* Reusable carousel arrow + dot controls */
.carousel-arrow-sm{
  width:40px; height:40px; border-radius:50%; border:1px solid var(--border); background: var(--white);
  display:flex; align-items:center; justify-content:center; color: var(--dark); flex-shrink:0;
  transition: background .15s ease, border-color .15s ease;
}
.carousel-arrow-sm svg{ width:18px; height:18px; }
.carousel-arrow-sm:hover:not(:disabled){ background: var(--lilac); border-color: var(--purple); color: var(--purple); }
.carousel-arrow-sm:disabled{ opacity:0.4; cursor:not-allowed; }
.carousel-arrow-side{
  position:absolute; top:50%; transform:translateY(-50%); z-index:2; box-shadow: var(--shadow-med);
}
.carousel-arrow-side-prev{ left:-8px; }
.carousel-arrow-side-next{ right:-8px; }
@media (max-width: 480px){
  .carousel-arrow-side-prev{ left:2px; }
  .carousel-arrow-side-next{ right:2px; }
}
.carousel-dots{ display:flex; justify-content:center; gap:6px; margin-top:18px; }
.carousel-dots .dot{ width:7px; height:7px; border-radius:50%; background: var(--border); transition: background .2s ease, width .2s ease; }
.carousel-dots .dot.active{ background: var(--purple); width:20px; border-radius:4px; }

/* ---------- Cara pakai ---------- */
.cara-tabs{ display:flex; gap:8px; flex-wrap:wrap; margin-bottom: 32px; }
.cara-tab{
  padding: 10px 18px; border-radius:999px; border:1px solid var(--border); background: var(--white);
  font-weight:700; font-size:0.875rem; min-height:44px; transition: background .15s ease, color .15s ease, border-color .15s ease;
}
.cara-tab[aria-selected="true"]{ background: var(--purple); color:#fff; border-color: var(--purple); }
.cara-tab:hover:not([aria-selected="true"]){ background: var(--lilac); }

.steps-wrap{ display:grid; grid-template-columns: 1fr 1fr; gap: 48px; align-items:center; }
@media (max-width: 900px){ .steps-wrap{ grid-template-columns: 1fr; gap: 32px; } }
.cara-subheading{ font-size: 1.15rem; font-weight: 800; color: var(--purple); margin-bottom: 22px; }
.steps-list{ display:flex; flex-direction:column; gap: 26px; }
.step-item{ display:flex; gap:16px; }
.step-num{
  width:40px; height:40px; border-radius:50%; background: var(--purple); color:#fff; font-weight:800;
  display:flex; align-items:center; justify-content:center; flex-shrink:0; font-size:0.95rem;
}
.step-item h3{ font-size:1.05rem; font-weight:700; }
.step-item p{ color: var(--medium); font-size:0.9375rem; margin-top:4px; }

.cara-visual{ background: var(--lilac); border-radius: var(--radius-lg); padding: 0; display:flex; align-items:center; justify-content:center; min-height:280px; overflow:hidden; }
.cara-visual svg{ width:100%; max-width: 320px; }
.cara-visual img{ width:100%; height:100%; object-fit:cover; display:block; min-height:280px; }

/* ---------- Ukuran locker ---------- */
.size-grid{ display:grid; grid-template-columns: repeat(4,1fr); gap:16px; }
@media (max-width: 700px){ .size-grid{ grid-template-columns: repeat(2,1fr); } }
.size-card{
  background: var(--white); border: 2px solid var(--border); border-radius: var(--radius-md);
  padding: 20px 16px; text-align:center; transition: border-color .15s ease, background .15s ease, transform .15s ease, box-shadow .15s ease;
  min-height: 44px;
}
.size-card:hover{ border-color: var(--purple); transform: translateY(-3px); box-shadow: var(--shadow-soft); }
.size-card[aria-checked="true"]{ border-color: var(--purple); background: var(--purple-tint); }
.size-letter{ font-size:1.6rem; font-weight:800; color: var(--purple); }
.size-label{ font-size:0.8125rem; color: var(--medium); margin-top:6px; display:block; }
.size-detail{
  margin-top:22px; background: var(--lilac); border-radius: var(--radius-md); padding: 20px 24px;
  display:flex; align-items:center; justify-content:space-between; gap:16px; flex-wrap:wrap;
}
.size-detail-text b{ font-size:1.05rem; }
.size-detail-text p{ color: var(--medium); font-size:0.9rem; margin-top:4px; }
.size-note-row{ display:flex; gap:10px; align-items:center; margin-top:18px; flex-wrap:wrap; }

.ukuran-grid-wrap{ display:grid; grid-template-columns: 1.15fr 0.85fr; gap: 40px; align-items:center; }
@media (max-width: 900px){ .ukuran-grid-wrap{ grid-template-columns: 1fr; gap:28px; } }
.cabinet-visual{ background: var(--lilac); border-radius: var(--radius-lg); padding: 0; overflow:hidden; }
.cabinet-visual img{ width:100%; display:block; }

.seli-box-card{
  margin-top: 28px; background: var(--white); border: 1px solid var(--border); border-radius: var(--radius-md);
  padding: 24px; display:flex; align-items:flex-start; gap:18px; flex-wrap:wrap;
}
.seli-box-icon{ width:52px; height:52px; border-radius:14px; background: var(--lilac); display:flex; align-items:center; justify-content:center; flex-shrink:0; }
.seli-box-icon svg{ width:26px; height:26px; color: var(--purple); }
.seli-box-text{ flex:1; min-width:220px; }
.seli-box-text p{ color: var(--medium); margin-top:6px; font-size:0.9375rem; }
.seli-box-dim{ display:inline-block; margin-top:10px; font-weight:700; font-size:0.8125rem; color: var(--purple); background: var(--lilac); padding:5px 12px; border-radius:999px; }

/* ---------- Location finder ---------- */
.finder-top-badge{ text-align:center; margin-bottom: 22px; }
.lokasi-final{ background: #FFF7E3; }
.finder-search{ display:flex; gap:10px; margin-bottom: 16px; flex-wrap:wrap; }
.finder-search-field{
  flex:1 1 240px; display:flex; align-items:center; gap:10px; background: var(--white);
  border:1px solid var(--border); border-radius: 999px; padding: 4px 6px 4px 16px;
}
.finder-search-field svg{ width:18px; height:18px; color: var(--medium); }
.finder-search-field input{ border:none; outline:none; background:transparent; flex:1; padding:11px 4px; font-size:0.9375rem; }

.filter-dropdown-wrap{ margin-bottom: 20px; max-width: 260px; }
.filter-select{
  width:100%; padding: 12px 16px; border-radius: 999px; border:1px solid var(--border);
  background: var(--white); font-size:0.9375rem; font-weight:600; min-height:44px;
  color: var(--dark); cursor:pointer;
}
.filter-select:focus-visible{ outline: 3px solid var(--purple); outline-offset:1px; }

.finder-view-toggle{ display:none; gap:8px; margin-bottom:16px; }
@media (max-width: 900px){ .finder-view-toggle{ display:flex; } }
.finder-view-toggle button{ flex:1; padding:10px; border-radius:10px; border:1px solid var(--border); font-weight:700; font-size:0.875rem; background:var(--white); }
.finder-view-toggle button[aria-pressed="true"]{ background: var(--purple); color:#fff; border-color:var(--purple); }

.finder-grid{ display:grid; grid-template-columns: 1.15fr 0.85fr; gap: 24px; align-items:start; }
@media (max-width: 900px){ .finder-grid{ grid-template-columns: 1fr; } }

.finder-list{ display:flex; flex-direction:column; gap:14px; }
@media (max-width: 900px){ .finder-list.hide-mobile{ display:none; } }
.finder-map-wrap{ position: sticky; top: 100px; }
@media (max-width: 900px){ .finder-map-wrap{ position:static; } .finder-map-wrap.hide-mobile{ display:none; } }

.loc-card{ background: var(--white); border:1px solid var(--border); border-radius: var(--radius-md); padding: 20px; }
.loc-card-top{ display:flex; justify-content:space-between; gap:10px; align-items:flex-start; }
.loc-card h3{ font-size:1rem; font-weight:700; }
.loc-card .loc-area{ font-size:0.8125rem; color: var(--medium); margin-top:2px; }
.loc-fields{ margin-top:14px; display:flex; flex-direction:column; gap:7px; }
.loc-field{ display:flex; justify-content:space-between; gap:10px; font-size:0.8438rem; }
.loc-field span:first-child{ color: var(--medium); }
.loc-actions{ display:flex; gap:8px; margin-top:16px; flex-wrap:wrap; }
.loc-detail-panel{
  margin-top:14px; padding-top:14px; border-top:1px dashed var(--border);
  font-size:0.8438rem; color: var(--medium); display:none;
}
.loc-detail-panel.open{ display:block; }

.finder-state{
  background: var(--white); border:1px dashed var(--border); border-radius: var(--radius-md);
  padding: 32px 20px; text-align:center; color: var(--medium); font-size:0.9375rem;
}
.finder-state svg{ width:34px; height:34px; margin: 0 auto 12px; color: var(--medium); }

.map-panel{
  background: var(--white); border:1px solid var(--border); border-radius: var(--radius-lg);
  overflow:hidden; position:relative; height:520px;
}
.map-panel iframe{ width:100%; height:100%; display:block; border:0; }
.map-fallback{
  width:100%; height:100%; display:flex; flex-direction:column; align-items:center; justify-content:center;
  gap:14px; padding:32px; text-align:center; background: var(--lilac);
}
.map-fallback svg{ width:40px; height:40px; color: var(--purple); }
.map-fallback p{ color: var(--medium); font-size:0.9375rem; line-height:1.5; }
.map-fallback p b{ color: var(--dark); }
@media (max-width: 900px){ .map-panel{ height:420px; } }

.app-download-section{ background: var(--lilac); }

.b2b-cta-section{ padding-top: 0; }
.b2b-cta-card{
  background: var(--purple); border-radius: var(--radius-lg); padding: 44px 40px;
  display:flex; flex-direction:column; align-items:center; text-align:center; gap:6px;
}
.b2b-cta-card .eyebrow{ background: rgba(255,255,255,0.14); color: var(--white); }
.b2b-cta-card h2{ color: var(--white); }
.b2b-cta-card .sub{ color: rgba(255,255,255,0.82); }
.b2b-cta-options{ display:grid; grid-template-columns: 1fr 1fr; gap:18px; max-width:720px; width:100%; margin: 26px 0 8px; text-align:left; }
@media (max-width:640px){ .b2b-cta-options{ grid-template-columns: 1fr; } }
.b2b-cta-option{ background: rgba(255,255,255,0.08); border-radius: var(--radius-md); padding: 20px; }
.b2b-cta-option h3{ color: var(--white); font-size:1.05rem; font-weight:800; margin-bottom:6px; }
.b2b-cta-option p{ color: rgba(255,255,255,0.82); font-size:0.9375rem; }
.b2b-cta-card .ads-showcase-wrap{ max-width:720px; width:100%; margin: 8px 0 14px; }
.b2b-cta-card .badge-demo{ margin-bottom: 22px; }
.b2b-cta-card .btn-primary{ background: var(--white); color: var(--purple); }
.b2b-cta-card .btn-primary:hover{ background: var(--yellow); color: var(--dark); }
@media (max-width: 767px){
  .b2b-cta-card{ padding: 30px 22px; }
  .b2b-cta-card .btn-primary{ width:100%; }
}

/* Branding Iklan CTA — horizontal sliding showcase */
.ads-showcase-wrap{ display:flex; align-items:center; gap:10px; }
.ads-showcase{
  display:flex; gap:16px; overflow-x:auto; scroll-snap-type:x mandatory;
  scrollbar-width:none; padding:4px 2px; flex:1;
}
.ads-showcase::-webkit-scrollbar{ display:none; height:0; }
.ads-thumb{
  flex:0 0 170px; aspect-ratio: 1/1; background: var(--lilac); border-radius: var(--radius-md);
  scroll-snap-align:start; overflow:hidden; position:relative; display:block; padding:0;
}
.ads-thumb img{
  position:absolute; inset:0; width:100%; height:100%; object-fit:cover;
  transition: transform 0.25s ease; transform: scale(1);
}
.ads-thumb:hover img, .ads-thumb.zoomed img{ transform: scale(1.18); }
.ads-thumb svg{ width:36px; height:36px; color: var(--purple); }
.ads-arrow{ background: rgba(255,255,255,0.14); border-color: rgba(255,255,255,0.3); color: var(--white); }
.ads-arrow:hover:not(:disabled){ background: rgba(255,255,255,0.24); border-color: rgba(255,255,255,0.5); color: var(--white); }

/* Partner logos */
.partner-marquee-wrap{
  overflow:hidden; margin-top:32px;
  -webkit-mask-image: linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent);
  mask-image: linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent);
}
.partner-marquee-track{ display:flex; gap:16px; width:max-content; animation: partnerMarquee 22s linear infinite; }
.partner-marquee-wrap:hover .partner-marquee-track{ animation-play-state: paused; }
@keyframes partnerMarquee{ from{ transform:translateX(0); } to{ transform:translateX(-50%); } }
.partner-logo-item{
  width:150px; height:70px; background: var(--white); border:1px solid var(--border); border-radius: var(--radius-sm);
  display:flex; align-items:center; justify-content:center; padding:14px 20px;
}
.partner-logo-item img{ max-width:100%; max-height:100%; object-fit:contain; }

/* Testimoni (spotlight carousel) */
.testimoni-spotlight-head{ max-width:640px; margin: 0 auto 32px; text-align:center; }
.testimoni-carousel-wrap{ display:flex; align-items:center; gap:16px; max-width:720px; margin:0 auto; }
.testimoni-spotlight-card{ flex:1; background: var(--white); border:1px solid var(--border); border-radius: var(--radius-lg); padding:36px; text-align:center; min-height:200px; }
.testimoni-stars{ display:flex; justify-content:center; gap:4px; margin-bottom:16px; }
.testimoni-stars svg{ width:18px; height:18px; color: var(--yellow); }
.testimoni-quote{ color: var(--dark); font-size:1.05rem; line-height:1.6; margin-bottom:20px; text-align:justify; text-align-last:center; }
.testimoni-quote::before{ content:"\201C"; }
.testimoni-quote::after{ content:"\201D"; }
.testimoni-author{ display:flex; align-items:center; justify-content:center; gap:10px; }
.testimoni-avatar{ width:38px; height:38px; border-radius:50%; background: var(--purple-tint); display:flex; align-items:center; justify-content:center; color: var(--purple); font-weight:800; font-size:0.875rem; flex-shrink:0; }
.testimoni-author-info{ text-align:left; }
.testimoni-author-name{ font-weight:700; font-size:0.875rem; }
.testimoni-author-role{ font-size:0.8125rem; color: var(--medium); }
@media (max-width:640px){
  .testimoni-carousel-wrap{ gap:8px; }
  .testimoni-spotlight-card{ padding:26px 18px; }
  .carousel-arrow-sm{ flex-shrink:0; }
}

/* Instagram feed mirror */
.ig-feed-section{ background: var(--lilac); }
.ig-feed-content{ text-align:center; max-width:640px; margin:0 auto; }
.ig-handle-pill{
  display:inline-flex; align-items:stretch; border:2px solid var(--purple); border-radius:16px;
  overflow:hidden; margin-top:24px; background: var(--white);
}
.ig-icon-box{ display:flex; align-items:center; justify-content:center; padding:14px 18px; border-right:2px solid var(--purple); }
.ig-icon-box svg{ width:24px; height:24px; color: var(--purple); }
.ig-handle-text{ display:flex; align-items:center; padding:14px 28px; font-weight:800; font-size:1.125rem; color: var(--purple); }

.app-download-block{ text-align:center; max-width:560px; margin:0 auto; }
.app-download-block h2{ margin-bottom:12px; }
.app-download-text{ font-weight:500; font-size:1rem; color: var(--medium); margin-bottom:26px; }
.app-download-badges{ display:flex; justify-content:center; gap:12px; flex-wrap:wrap; }
.app-badge{
  display:flex; align-items:center; gap:10px; background: var(--dark); color:#fff;
  padding: 10px 18px; border-radius: 12px; min-height:44px;
}
.app-badge:hover{ background:#2c2c2c; }
.app-badge svg{ width:24px; height:24px; flex-shrink:0; }
.app-badge span{ display:flex; flex-direction:column; align-items:flex-start; text-align:left; font-weight:700; font-size:0.9375rem; line-height:1.2; }
.app-badge span small{ font-weight:400; font-size:0.6875rem; text-transform:capitalize; }

/* ---------- Trust section ---------- */
.trust-band{ background: var(--lilac); }
.trust-more{ margin-top:24px; }
.trust-more-note{
  margin-top:10px; font-size:0.8438rem; color: var(--medium); max-width:520px; display:none;
  background: var(--white); border-radius: var(--radius-sm); padding:12px 16px;
}
.trust-more-note.open{ display:block; }

/* ---------- FAQ ---------- */
.faq-list{ display:flex; flex-direction:column; border-top:1px solid var(--border); max-width: 780px; }
.faq-item{ border-bottom:1px solid var(--border); }
.faq-q{
  width:100%; display:flex; justify-content:space-between; align-items:center; gap:16px;
  padding: 20px 4px; text-align:left; font-weight:700; font-size:1rem; min-height:44px;
}
.faq-icon{ width:22px; height:22px; flex-shrink:0; color: var(--purple); transition: transform .2s ease; }
.faq-q[aria-expanded="true"] .faq-icon{ transform: rotate(45deg); }
.faq-a{ overflow:hidden; max-height:0; transition: max-height .25s ease; }
.faq-a-inner{ padding: 0 4px 20px; color: var(--medium); font-size:0.9375rem; max-width: 680px; }
.faq-bottom{ margin-top: 34px; display:flex; align-items:center; gap:14px; flex-wrap:wrap; }

/* ---------- Footer ---------- */
footer.site-footer{ background: #2E2E33; color: #E4E3E8; padding: 56px 0 28px; }
.footer-grid{ display:grid; grid-template-columns: 1.4fr 1fr 1fr 1fr; gap: 32px; }
.footer-grid-4{ grid-template-columns: 1.2fr 1fr 1fr 1fr; }
.footer-grid-5{ grid-template-columns: 1fr 1fr 1fr 1.5fr 1.1fr; }
@media (max-width: 1024px){ .footer-grid-5{ grid-template-columns: 1fr 1fr 1fr; } }
@media (max-width: 640px){ .footer-grid-5{ grid-template-columns: 1fr 1fr; } }
@media (max-width: 460px){ .footer-grid-5{ grid-template-columns: 1fr; } }
@media (max-width: 900px){ .footer-grid{ grid-template-columns: 1fr 1fr; } }
@media (max-width: 560px){ .footer-grid{ grid-template-columns: 1fr; } }
.footer-brand{ display:flex; align-items:center; margin-bottom:10px; }
.footer-brand-logo{ height:32px; width:auto; display:block; }
.footer-col h4{ font-size:0.8125rem; text-transform:uppercase; letter-spacing:0.06em; color:#9C9BA6; margin-bottom:14px; }
.footer-col ul{ display:flex; flex-direction:column; gap:10px; }
.footer-col ul.footer-list-spaced{ margin-top:20px; }
.footer-col button, .footer-col a{ font-size:0.9375rem; color:#E4E3E8; text-align:left; min-height:auto; }
.footer-col button:hover, .footer-col a:hover{ color: var(--yellow); }
.footer-link-strong{ font-weight:700; }
/* Column heading that is also a link (Bantuan → paxel.co help centre): keep the heading look. */
.footer-col h4 .footer-heading-link{ font-size:inherit; color:inherit; }
.footer-col h4 .footer-heading-link:hover{ color: var(--yellow); }
.footer-info-text{ font-size:0.9375rem; color:#E4E3E8; line-height:1.5; margin-bottom:8px; }
.footer-info-text.footer-list-spaced{ margin-top:16px; }
.demo-tag{ font-size:0.6875rem; color:#9C9BA6; margin-left:4px; }
.footer-bottom{ margin-top:44px; padding-top:24px; border-top:1px solid rgba(255,255,255,0.1); display:flex; justify-content:space-between; gap:16px; flex-wrap:wrap; align-items:center; }
.footer-bottom-brand{ align-items:center; }
.social-row{ display:flex; gap:10px; flex-wrap:wrap; }
.social-row a{ width:38px; height:38px; border-radius:50%; background: rgba(255,255,255,0.08); display:flex; align-items:center; justify-content:center; }
.social-row a:hover{ background: rgba(255,255,255,0.16); }
.social-row svg{ width:16px; height:16px; }
.social-row img{ width:16px; height:16px; display:block; }
.footer-app-badges{ display:flex; flex-direction:column; gap:10px; }
.footer-app-badges .app-badge{ background:#000; border:1px solid rgba(255,255,255,0.15); }
.footer-app-badges .app-badge:hover{ background:#161616; }
.copyright{ font-size:0.8125rem; color:#9C9BA6; }

/* ---------- Toast ---------- */
.demo-toast{
  position: fixed; left:50%; bottom: 24px; transform: translateX(-50%) translateY(140%);
  background: var(--dark); color:#fff; padding: 13px 20px; border-radius: 999px;
  font-size:0.875rem; max-width: min(420px, 86vw); text-align:center; z-index: 900;
  box-shadow: var(--shadow-med); transition: transform .25s ease;
}
.demo-toast.visible{ transform: translateX(-50%) translateY(0); }
@media (max-width:767px){ .demo-toast{ bottom: 92px; } }

.visually-hidden{
  position:absolute; width:1px; height:1px; padding:0; margin:-1px; overflow:hidden;
  clip:rect(0,0,0,0); white-space:nowrap; border:0;
}

/* --- additions for the Vue port (language toggle, neutralized placeholders) --- */
.lang-toggle{ display:flex; gap:2px; background: var(--lilac); border-radius:999px; padding:3px; }
.lang-toggle button{ padding:5px 10px; border-radius:999px; font-weight:700; font-size:0.8125rem; color: var(--medium); min-height:32px; }
.lang-toggle button.active{ background: var(--purple); color:#fff; }
.link-btn{ text-decoration:underline; font-weight:700; color:inherit; }
.partner-placeholder{ font-size:0.75rem; color: var(--medium); text-align:center; line-height:1.3; }
</style>
